import { Pipe, PipeTransform } from '@angular/core';

import { marked } from 'marked';

@Pipe({
  standalone: true,
  name: 'parseMarkdown',
  pure: true,
})
export class ParseMarkdownPipe implements PipeTransform {
  transform(value: string): string {
    value = value
      .replace(/\n\n<ul>/gi, '<ul>')
      .replace(/<\/ul>\n\n/gi, '\n</ul>')
      .replace(/<ol>\n/gi, '<ol>')
      .replace(/<\/ol>\n/gi, '</ol>')
      .replace(/<\/li>\n/gi, '</li>');

    return marked.parseInline(value, { async: false });
  }
}
